module.exports = __webpack_public_path__ + "img/iPad Pro 12.9 - 1.3601e21d.jpg";